<template>
	<div class="commonDialog" @click="close">
		<div class="mask"></div>
		<div class="content">
            <!-- <img src="../../../assets/images/preview/detail-img.png" alt=""> -->
            <img class="close-icon" src="../../../assets/images/preview/close-icon.png" alt="">
		</div>
	</div>
</template>
<script>
	export default {
		methods: {
			close() {
				this.$emit("close")
			}
		}
	};
</script>
<style lang="less" scoped>
	@import "./detailDialog.less";
</style>
